module.exports = __webpack_public_path__ + "static/media/Canvas_508-07.ecfcbc2f.jpg";